import React from 'react';
import './Loader.scss';
import loadingSpinners from '../../../assets/loadingSpinners.gif';

const Loader = () => {
  return (
    <div className="loader-page">
      <img src={loadingSpinners} alt="로딩 스피너"></img>
    </div>
  );
};

export default Loader;
